export default __webpack_public_path__ + "static/media/boBurnham.7b5ab90a.jpeg";